export default function reportAddToCart(product: string, element: string) {
  window.nostojs((api) => {
    api.defaultSession().reportAddToCart(product, element).update();
  });
}
